export default __webpack_public_path__ + "static/media/WorkSans-Thin.2e3bceac.ttf";